import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "closing-settlement-modal",
  "data-tour": "bb-test-settlement-dialog"
}
const _hoisted_2 = { class: "csm-header" }
const _hoisted_3 = { class: "csm-header-icon" }
const _hoisted_4 = { class: "csm-header-text" }
const _hoisted_5 = { class: "csm-toolbar" }
const _hoisted_6 = {
  key: 0,
  class: "csm-period"
}
const _hoisted_7 = { class: "csm-body" }
const _hoisted_8 = {
  key: 0,
  class: "csm-state"
}
const _hoisted_9 = {
  key: 1,
  class: "csm-state is-error"
}
const _hoisted_10 = {
  key: 2,
  class: "csm-table-wrap"
}
const _hoisted_11 = { class: "csm-table" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["rowspan"]
const _hoisted_14 = ["rowspan"]
const _hoisted_15 = { class: "code" }
const _hoisted_16 = ["rowspan"]
const _hoisted_17 = { class: "code" }
const _hoisted_18 = {
  key: 3,
  rowspan: 3,
  class: "cell-mok"
}
const _hoisted_19 = {
  key: 0,
  rowspan: 3,
  class: "sub-label"
}
const _hoisted_20 = {
  key: 0,
  rowspan: 3,
  colspan: "2",
  class: "sub-label"
}
const _hoisted_21 = { class: "total-row" }
const _hoisted_22 = { class: "cell-amt" }
const _hoisted_23 = { class: "cell-amt" }
const _hoisted_24 = { class: "cell-amt" }
const _hoisted_25 = { class: "cell-amt" }
const _hoisted_26 = { class: "total-row" }
const _hoisted_27 = { class: "cell-amt" }
const _hoisted_28 = { class: "cell-amt" }
const _hoisted_29 = { class: "cell-amt" }
const _hoisted_30 = { class: "cell-amt" }
const _hoisted_31 = { class: "total-row diff-row" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = ["rowspan"]
const _hoisted_34 = ["rowspan"]
const _hoisted_35 = { class: "code" }
const _hoisted_36 = ["rowspan"]
const _hoisted_37 = { class: "code" }
const _hoisted_38 = {
  key: 3,
  rowspan: 3,
  class: "cell-mok"
}
const _hoisted_39 = {
  key: 0,
  rowspan: 3,
  class: "sub-label"
}
const _hoisted_40 = {
  key: 0,
  rowspan: 3,
  colspan: "2",
  class: "sub-label"
}
const _hoisted_41 = { class: "total-row" }
const _hoisted_42 = { class: "cell-amt" }
const _hoisted_43 = { class: "cell-amt" }
const _hoisted_44 = { class: "cell-amt" }
const _hoisted_45 = { class: "cell-amt" }
const _hoisted_46 = { class: "total-row" }
const _hoisted_47 = { class: "cell-amt" }
const _hoisted_48 = { class: "cell-amt" }
const _hoisted_49 = { class: "cell-amt" }
const _hoisted_50 = { class: "cell-amt" }
const _hoisted_51 = { class: "total-row diff-row" }

import { computed, ref, watch } from 'vue';
import { bankbookApi } from '@/services/api';

interface AmtRow {
  source: string;
  정부보조금: number;
  시설보조: number;
  후원금: number;
  총액: number;
}

interface FlatRow extends AmtRow {
  gubun: string;
  관: string;
  lcode: string;
  항: string;
  mcode: string;
  목: string;
  scode: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClosingSettlementModal',
  props: {
    modelValue: { type: Boolean },
    memberCode: {},
    year: {},
    month: {},
    bizGubun: {},
    bankCode: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const loading = ref(false);
const error = ref('');
const payload = ref<any>(null);
const mainGubun = ref<'전체' | '세입' | '세출'>('전체');

const periodHint = computed(() =>
  payload.value?.cumulativeLabel
  || (Number(props.month) <= 1 ? '1월' : `1~${Number(props.month)}월`)
);

const emptyTotals = () => ({
  예산: { 정부보조금: 0, 시설보조: 0, 후원금: 0, 총액: 0 },
  결산: { 정부보조금: 0, 시설보조: 0, 후원금: 0, 총액: 0 },
  증감: { 정부보조금: 0, 시설보조: 0, 후원금: 0, 총액: 0 },
});

const parseAmt = (v: unknown) => Number(v) || 0;

const calcSubtotals = (items: FlatRow[]): AmtRow[] =>
  (['예산', '결산', '증감'] as const).map((source) => {
    const list = items.filter((i) => i.source === source);
    return {
      source,
      정부보조금: list.reduce((s, i) => s + parseAmt(i.정부보조금), 0),
      시설보조: list.reduce((s, i) => s + parseAmt(i.시설보조), 0),
      후원금: list.reduce((s, i) => s + parseAmt(i.후원금), 0),
      총액: list.reduce((s, i) => s + parseAmt(i.총액), 0),
    };
  });

const groupData = (dataList: FlatRow[]) => {
  if (!dataList.length) return [];
  const gwanGroups: any[] = [];
  let currentGwan: any = null;
  let currentHang: any = null;
  let currentMok: any = null;

  for (const item of dataList) {
    if (!currentGwan || currentGwan.gwan !== item.관 || currentGwan.gubun !== item.gubun) {
      currentGwan = {
        gubun: item.gubun,
        gwan: item.관,
        lcode: item.lcode,
        hangGroups: [],
        subtotals: [] as AmtRow[],
        showSubtotal: false,
        totalRows: 0,
      };
      gwanGroups.push(currentGwan);
      currentHang = null;
      currentMok = null;
    }
    if (!currentHang || currentHang.hang !== item.항) {
      currentHang = {
        hang: item.항,
        mcode: item.mcode,
        mokGroups: [],
        subtotals: [] as AmtRow[],
        showSubtotal: false,
        totalRows: 0,
      };
      currentGwan.hangGroups.push(currentHang);
      currentMok = null;
    }
    if (!currentMok || currentMok.mok !== item.목) {
      currentMok = { mok: item.목, scode: item.scode, rows: [] as FlatRow[] };
      currentHang.mokGroups.push(currentMok);
    }
    currentMok.rows.push(item);
  }

  for (const gwan of gwanGroups) {
    for (const hang of gwan.hangGroups) {
      const allHangRows = hang.mokGroups.flatMap((m: any) => m.rows);
      hang.subtotals = calcSubtotals(allHangRows);
      hang.showSubtotal = hang.mokGroups.length >= 2;
      hang.totalRows = hang.mokGroups.length * 3 + (hang.showSubtotal ? 3 : 0);
    }
    const allGwanRows = gwan.hangGroups.flatMap((h: any) =>
      h.mokGroups.flatMap((m: any) => m.rows)
    );
    gwan.subtotals = calcSubtotals(allGwanRows);
    gwan.showSubtotal = gwan.hangGroups.length >= 2;
    gwan.totalRows = gwan.hangGroups.reduce((sum: number, h: any) => sum + h.totalRows, 0)
      + (gwan.showSubtotal ? 3 : 0);
  }
  return gwanGroups;
};

const groupedIn = computed(() => groupData(payload.value?.income?.rows || []));
const groupedOut = computed(() => groupData(payload.value?.expense?.rows || []));
const inGubunRows = computed(() =>
  groupedIn.value.reduce((sum: number, g: any) => sum + g.totalRows, 0)
);
const outGubunRows = computed(() =>
  groupedOut.value.reduce((sum: number, g: any) => sum + g.totalRows, 0)
);
const inTotals = computed(() => payload.value?.income?.totals || emptyTotals());
const outTotals = computed(() => payload.value?.expense?.totals || emptyTotals());

const formatAmt = (n: number | null | undefined) => (Number(n) || 0).toLocaleString('ko-KR');
const sourceClass = (source: string) => ({
  'source-budget': source === '예산',
  'source-closing': source === '결산',
  'source-diff': source === '증감',
});
const negClass = (row: { source?: string; 총액?: number } | AmtRow) => ({
  negative: parseAmt((row as any).총액) < 0,
});

const load = async () => {
  if (!props.memberCode || !props.year || !props.month) return;
  loading.value = true;
  error.value = '';
  payload.value = null;
  try {
    const res = await bankbookApi.getSettlementView(String(props.memberCode), {
      year: String(props.year),
      month: String(props.month),
      bizGubun: props.bizGubun || undefined,
      bankCode: props.bankCode,
    });
    payload.value = res.data?.data || null;
    if (!payload.value) error.value = '결산 데이터가 없습니다.';
  } catch (e: any) {
    console.error(e);
    error.value = e?.response?.data?.message || '결산을 불러오지 못했습니다.';
  } finally {
    loading.value = false;
  }
};

watch(
  () => props.modelValue,
  (open) => {
    if (open) {
      mainGubun.value = '전체';
      load();
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "1200",
    scrollable: "",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              size: "22",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("mdi-table-large", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("h3", null, "결산", -1)),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(__props.year) + "년 " + _toDisplayString(periodHint.value) + " ", 1),
              (__props.bizGubun)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" · " + _toDisplayString(__props.bizGubun), 1)
                  ], 64))
                : _createCommentVNode("", true),
              _cache[4] || (_cache[4] = _createTextVNode(" · 예산 / 결산 / 증감 ", -1))
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "csm-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
          }, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "csm-filter-label" }, "구분", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((mainGubun).value = $event)),
            class: "csm-filter-select"
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("option", { value: "전체" }, "전체", -1),
            _createElementVNode("option", { value: "세입" }, "세입", -1),
            _createElementVNode("option", { value: "세출" }, "세출", -1)
          ]))], 512), [
            [_vModelSelect, mainGubun.value]
          ]),
          (payload.value?.periodLabel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(payload.value.periodLabel), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  size: "28",
                  width: "2",
                  color: "#1e3a5f"
                }),
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "결산 불러오는 중...", -1))
              ]))
            : (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("p", null, _toDisplayString(error.value), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "csm-retry",
                    onClick: load
                  }, "다시 시도")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("table", _hoisted_11, [
                    _cache[24] || (_cache[24] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "col-gubun" }, "구분"),
                        _createElementVNode("th", { class: "col-gwan" }, "관"),
                        _createElementVNode("th", { class: "col-hang" }, "항"),
                        _createElementVNode("th", { class: "col-mok" }, "목"),
                        _createElementVNode("th", { class: "col-source" }, "구분"),
                        _createElementVNode("th", { class: "col-amt" }, "정부보조금"),
                        _createElementVNode("th", { class: "col-amt" }, "시설보조"),
                        _createElementVNode("th", { class: "col-amt" }, "후원금"),
                        _createElementVNode("th", { class: "col-amt" }, "계")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (mainGubun.value === '전체' || mainGubun.value === '세입')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (!groupedIn.value.length)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [...(_cache[10] || (_cache[10] = [
                                  _createElementVNode("td", {
                                    colspan: "9",
                                    class: "empty-cell"
                                  }, "세입 계정과목이 없습니다", -1)
                                ]))]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedIn.value, (gwan, gwanIdx) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                      key: 'in-g-' + gwanIdx
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gwan.hangGroups, (hang, hangIdx) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                          key: 'in-h-' + gwanIdx + '-' + hangIdx
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hang.mokGroups, (mok, mokIdx) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, {
                                              key: 'in-m-' + gwanIdx + '-' + hangIdx + '-' + mokIdx
                                            }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mok.rows, (row, rowIdx) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                  key: 'in-r-' + gwanIdx + '-' + hangIdx + '-' + mokIdx + '-' + rowIdx,
                                                  class: _normalizeClass({ 'diff-row': row.source === '증감' })
                                                }, [
                                                  (gwanIdx === 0 && hangIdx === 0 && mokIdx === 0 && rowIdx === 0)
                                                    ? (_openBlock(), _createElementBlock("td", {
                                                        key: 0,
                                                        rowspan: inGubunRows.value,
                                                        class: "cell-gubun"
                                                      }, "세입", 8, _hoisted_13))
                                                    : _createCommentVNode("", true),
                                                  (hangIdx === 0 && mokIdx === 0 && rowIdx === 0)
                                                    ? (_openBlock(), _createElementBlock("td", {
                                                        key: 1,
                                                        rowspan: gwan.totalRows,
                                                        class: "cell-gwan"
                                                      }, [
                                                        _createTextVNode(_toDisplayString(gwan.gwan), 1),
                                                        _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                                                        _createElementVNode("span", _hoisted_15, _toDisplayString(gwan.lcode), 1)
                                                      ], 8, _hoisted_14))
                                                    : _createCommentVNode("", true),
                                                  (mokIdx === 0 && rowIdx === 0)
                                                    ? (_openBlock(), _createElementBlock("td", {
                                                        key: 2,
                                                        rowspan: hang.totalRows,
                                                        class: "cell-hang"
                                                      }, [
                                                        _createTextVNode(_toDisplayString(hang.hang), 1),
                                                        _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                                                        _createElementVNode("span", _hoisted_17, _toDisplayString(hang.mcode), 1)
                                                      ], 8, _hoisted_16))
                                                    : _createCommentVNode("", true),
                                                  (rowIdx === 0)
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(mok.mok), 1))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-source", sourceClass(row.source)])
                                                  }, _toDisplayString(row.source), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(row)])
                                                  }, _toDisplayString(formatAmt(row.정부보조금)), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(row)])
                                                  }, _toDisplayString(formatAmt(row.시설보조)), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(row)])
                                                  }, _toDisplayString(formatAmt(row.후원금)), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(row)])
                                                  }, _toDisplayString(formatAmt(row.총액)), 3)
                                                ], 2))
                                              }), 128))
                                            ], 64))
                                          }), 128)),
                                          (hang.showSubtotal)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(hang.subtotals, (sub, subIdx) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                  key: 'in-hs-' + gwanIdx + '-' + hangIdx + '-' + subIdx,
                                                  class: _normalizeClass(["subtotal-row hang-sub", { 'diff-row': sub.source === '증감' }])
                                                }, [
                                                  (subIdx === 0)
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_19, "소계"))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-source", sourceClass(sub.source)])
                                                  }, _toDisplayString(sub.source), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(sub)])
                                                  }, _toDisplayString(formatAmt(sub.정부보조금)), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(sub)])
                                                  }, _toDisplayString(formatAmt(sub.시설보조)), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(sub)])
                                                  }, _toDisplayString(formatAmt(sub.후원금)), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(sub)])
                                                  }, _toDisplayString(formatAmt(sub.총액)), 3)
                                                ], 2))
                                              }), 128))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128)),
                                      (gwan.showSubtotal)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(gwan.subtotals, (sub, subIdx) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: 'in-gs-' + gwanIdx + '-' + subIdx,
                                              class: _normalizeClass(["subtotal-row gwan-sub", { 'diff-row': sub.source === '증감' }])
                                            }, [
                                              (subIdx === 0)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_20, "소계"))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("td", {
                                                class: _normalizeClass(["cell-source", sourceClass(sub.source)])
                                              }, _toDisplayString(sub.source), 3),
                                              _createElementVNode("td", {
                                                class: _normalizeClass(["cell-amt", negClass(sub)])
                                              }, _toDisplayString(formatAmt(sub.정부보조금)), 3),
                                              _createElementVNode("td", {
                                                class: _normalizeClass(["cell-amt", negClass(sub)])
                                              }, _toDisplayString(formatAmt(sub.시설보조)), 3),
                                              _createElementVNode("td", {
                                                class: _normalizeClass(["cell-amt", negClass(sub)])
                                              }, _toDisplayString(formatAmt(sub.후원금)), 3),
                                              _createElementVNode("td", {
                                                class: _normalizeClass(["cell-amt", negClass(sub)])
                                              }, _toDisplayString(formatAmt(sub.총액)), 3)
                                            ], 2))
                                          }), 128))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128)),
                                  _createElementVNode("tr", _hoisted_21, [
                                    _cache[13] || (_cache[13] = _createElementVNode("td", {
                                      class: "total-label",
                                      colspan: "4",
                                      rowspan: "3"
                                    }, "세입 합계", -1)),
                                    _cache[14] || (_cache[14] = _createElementVNode("td", { class: "cell-source source-budget" }, "예산", -1)),
                                    _createElementVNode("td", _hoisted_22, _toDisplayString(formatAmt(inTotals.value.예산.정부보조금)), 1),
                                    _createElementVNode("td", _hoisted_23, _toDisplayString(formatAmt(inTotals.value.예산.시설보조)), 1),
                                    _createElementVNode("td", _hoisted_24, _toDisplayString(formatAmt(inTotals.value.예산.후원금)), 1),
                                    _createElementVNode("td", _hoisted_25, _toDisplayString(formatAmt(inTotals.value.예산.총액)), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_26, [
                                    _cache[15] || (_cache[15] = _createElementVNode("td", { class: "cell-source source-closing" }, "결산", -1)),
                                    _createElementVNode("td", _hoisted_27, _toDisplayString(formatAmt(inTotals.value.결산.정부보조금)), 1),
                                    _createElementVNode("td", _hoisted_28, _toDisplayString(formatAmt(inTotals.value.결산.시설보조)), 1),
                                    _createElementVNode("td", _hoisted_29, _toDisplayString(formatAmt(inTotals.value.결산.후원금)), 1),
                                    _createElementVNode("td", _hoisted_30, _toDisplayString(formatAmt(inTotals.value.결산.총액)), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_31, [
                                    _cache[16] || (_cache[16] = _createElementVNode("td", { class: "cell-source source-diff" }, "증감", -1)),
                                    _createElementVNode("td", {
                                      class: _normalizeClass(["cell-amt", negClass(inTotals.value.증감)])
                                    }, _toDisplayString(formatAmt(inTotals.value.증감.정부보조금)), 3),
                                    _createElementVNode("td", {
                                      class: _normalizeClass(["cell-amt", negClass(inTotals.value.증감)])
                                    }, _toDisplayString(formatAmt(inTotals.value.증감.시설보조)), 3),
                                    _createElementVNode("td", {
                                      class: _normalizeClass(["cell-amt", negClass(inTotals.value.증감)])
                                    }, _toDisplayString(formatAmt(inTotals.value.증감.후원금)), 3),
                                    _createElementVNode("td", {
                                      class: _normalizeClass(["cell-amt", negClass(inTotals.value.증감)])
                                    }, _toDisplayString(formatAmt(inTotals.value.증감.총액)), 3)
                                  ])
                                ], 64))
                          ], 64))
                        : _createCommentVNode("", true),
                      (mainGubun.value === '전체' || mainGubun.value === '세출')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (!groupedOut.value.length)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [...(_cache[17] || (_cache[17] = [
                                  _createElementVNode("td", {
                                    colspan: "9",
                                    class: "empty-cell"
                                  }, "세출 계정과목이 없습니다", -1)
                                ]))]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedOut.value, (gwan, gwanIdx) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                      key: 'out-g-' + gwanIdx
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gwan.hangGroups, (hang, hangIdx) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                          key: 'out-h-' + gwanIdx + '-' + hangIdx
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hang.mokGroups, (mok, mokIdx) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, {
                                              key: 'out-m-' + gwanIdx + '-' + hangIdx + '-' + mokIdx
                                            }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mok.rows, (row, rowIdx) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                  key: 'out-r-' + gwanIdx + '-' + hangIdx + '-' + mokIdx + '-' + rowIdx,
                                                  class: _normalizeClass({ 'diff-row': row.source === '증감' })
                                                }, [
                                                  (gwanIdx === 0 && hangIdx === 0 && mokIdx === 0 && rowIdx === 0)
                                                    ? (_openBlock(), _createElementBlock("td", {
                                                        key: 0,
                                                        rowspan: outGubunRows.value,
                                                        class: "cell-gubun"
                                                      }, "세출", 8, _hoisted_33))
                                                    : _createCommentVNode("", true),
                                                  (hangIdx === 0 && mokIdx === 0 && rowIdx === 0)
                                                    ? (_openBlock(), _createElementBlock("td", {
                                                        key: 1,
                                                        rowspan: gwan.totalRows,
                                                        class: "cell-gwan"
                                                      }, [
                                                        _createTextVNode(_toDisplayString(gwan.gwan), 1),
                                                        _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                                                        _createElementVNode("span", _hoisted_35, _toDisplayString(gwan.lcode), 1)
                                                      ], 8, _hoisted_34))
                                                    : _createCommentVNode("", true),
                                                  (mokIdx === 0 && rowIdx === 0)
                                                    ? (_openBlock(), _createElementBlock("td", {
                                                        key: 2,
                                                        rowspan: hang.totalRows,
                                                        class: "cell-hang"
                                                      }, [
                                                        _createTextVNode(_toDisplayString(hang.hang), 1),
                                                        _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                                                        _createElementVNode("span", _hoisted_37, _toDisplayString(hang.mcode), 1)
                                                      ], 8, _hoisted_36))
                                                    : _createCommentVNode("", true),
                                                  (rowIdx === 0)
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_38, _toDisplayString(mok.mok), 1))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-source", sourceClass(row.source)])
                                                  }, _toDisplayString(row.source), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(row)])
                                                  }, _toDisplayString(formatAmt(row.정부보조금)), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(row)])
                                                  }, _toDisplayString(formatAmt(row.시설보조)), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(row)])
                                                  }, _toDisplayString(formatAmt(row.후원금)), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(row)])
                                                  }, _toDisplayString(formatAmt(row.총액)), 3)
                                                ], 2))
                                              }), 128))
                                            ], 64))
                                          }), 128)),
                                          (hang.showSubtotal)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(hang.subtotals, (sub, subIdx) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                  key: 'out-hs-' + gwanIdx + '-' + hangIdx + '-' + subIdx,
                                                  class: _normalizeClass(["subtotal-row hang-sub", { 'diff-row': sub.source === '증감' }])
                                                }, [
                                                  (subIdx === 0)
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_39, "소계"))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-source", sourceClass(sub.source)])
                                                  }, _toDisplayString(sub.source), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(sub)])
                                                  }, _toDisplayString(formatAmt(sub.정부보조금)), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(sub)])
                                                  }, _toDisplayString(formatAmt(sub.시설보조)), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(sub)])
                                                  }, _toDisplayString(formatAmt(sub.후원금)), 3),
                                                  _createElementVNode("td", {
                                                    class: _normalizeClass(["cell-amt", negClass(sub)])
                                                  }, _toDisplayString(formatAmt(sub.총액)), 3)
                                                ], 2))
                                              }), 128))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128)),
                                      (gwan.showSubtotal)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(gwan.subtotals, (sub, subIdx) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: 'out-gs-' + gwanIdx + '-' + subIdx,
                                              class: _normalizeClass(["subtotal-row gwan-sub", { 'diff-row': sub.source === '증감' }])
                                            }, [
                                              (subIdx === 0)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_40, "소계"))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("td", {
                                                class: _normalizeClass(["cell-source", sourceClass(sub.source)])
                                              }, _toDisplayString(sub.source), 3),
                                              _createElementVNode("td", {
                                                class: _normalizeClass(["cell-amt", negClass(sub)])
                                              }, _toDisplayString(formatAmt(sub.정부보조금)), 3),
                                              _createElementVNode("td", {
                                                class: _normalizeClass(["cell-amt", negClass(sub)])
                                              }, _toDisplayString(formatAmt(sub.시설보조)), 3),
                                              _createElementVNode("td", {
                                                class: _normalizeClass(["cell-amt", negClass(sub)])
                                              }, _toDisplayString(formatAmt(sub.후원금)), 3),
                                              _createElementVNode("td", {
                                                class: _normalizeClass(["cell-amt", negClass(sub)])
                                              }, _toDisplayString(formatAmt(sub.총액)), 3)
                                            ], 2))
                                          }), 128))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128)),
                                  _createElementVNode("tr", _hoisted_41, [
                                    _cache[20] || (_cache[20] = _createElementVNode("td", {
                                      class: "total-label",
                                      colspan: "4",
                                      rowspan: "3"
                                    }, "세출 합계", -1)),
                                    _cache[21] || (_cache[21] = _createElementVNode("td", { class: "cell-source source-budget" }, "예산", -1)),
                                    _createElementVNode("td", _hoisted_42, _toDisplayString(formatAmt(outTotals.value.예산.정부보조금)), 1),
                                    _createElementVNode("td", _hoisted_43, _toDisplayString(formatAmt(outTotals.value.예산.시설보조)), 1),
                                    _createElementVNode("td", _hoisted_44, _toDisplayString(formatAmt(outTotals.value.예산.후원금)), 1),
                                    _createElementVNode("td", _hoisted_45, _toDisplayString(formatAmt(outTotals.value.예산.총액)), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_46, [
                                    _cache[22] || (_cache[22] = _createElementVNode("td", { class: "cell-source source-closing" }, "결산", -1)),
                                    _createElementVNode("td", _hoisted_47, _toDisplayString(formatAmt(outTotals.value.결산.정부보조금)), 1),
                                    _createElementVNode("td", _hoisted_48, _toDisplayString(formatAmt(outTotals.value.결산.시설보조)), 1),
                                    _createElementVNode("td", _hoisted_49, _toDisplayString(formatAmt(outTotals.value.결산.후원금)), 1),
                                    _createElementVNode("td", _hoisted_50, _toDisplayString(formatAmt(outTotals.value.결산.총액)), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_51, [
                                    _cache[23] || (_cache[23] = _createElementVNode("td", { class: "cell-source source-diff" }, "증감", -1)),
                                    _createElementVNode("td", {
                                      class: _normalizeClass(["cell-amt", negClass(outTotals.value.증감)])
                                    }, _toDisplayString(formatAmt(outTotals.value.증감.정부보조금)), 3),
                                    _createElementVNode("td", {
                                      class: _normalizeClass(["cell-amt", negClass(outTotals.value.증감)])
                                    }, _toDisplayString(formatAmt(outTotals.value.증감.시설보조)), 3),
                                    _createElementVNode("td", {
                                      class: _normalizeClass(["cell-amt", negClass(outTotals.value.증감)])
                                    }, _toDisplayString(formatAmt(outTotals.value.증감.후원금)), 3),
                                    _createElementVNode("td", {
                                      class: _normalizeClass(["cell-amt", negClass(outTotals.value.증감)])
                                    }, _toDisplayString(formatAmt(outTotals.value.증감.총액)), 3)
                                  ])
                                ], 64))
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})